/*
 * Radius
 * v1.0
 * 31.08.2022
 */

const radius = {
  /**
   * Radius is set to 4px
   */
  extraSmall: 4,
  /**
   * Radius is set to 8px
   */
  small: 8,
  /**
   * Radius is set to 12px
   */
  medium: 12,
  /**
   * Radius is set to 16px
   */
  large: 16,
  /**
   * Radius is set to 24px
   */
  extraLarge: 24,
} as const;

export default radius;
